import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/u3dDataShow',
    name: 'u3dDataShow',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/U3dDataShow.vue')
  },
  {
    path: '/seconddxz',
    name: 'seconddxz',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../itemviews/seconddxz.vue')
  },
  {
    path:'/CjhomeShow',
    name:'CjhomeShow',
    component:()=>import('../views/CjhomeShow.vue')
  },
  {
    path:'/CityBuildShow',
    name:'CityBuildShow',
    component:()=>import('../views/CityBuildShow.vue')
  },
  {
    path:'/CityNavigation',
    name:'CityNavigation',
    component:()=>import('../views/CityNavigation.vue')
  },
  {
    path:'/ZlthomePage',
    name:'ZlthomePage',
    component:()=>import('../views/ZlthomePage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
